import { TombacItem } from "../internal/TombacItem";
import { Menu } from "./LegacyMenu";
import { MenuDropdown } from "./MenuDropdown";
import { MenuRoot } from "./MenuRoot";
const ExtendedMenu = Menu;
ExtendedMenu.Dropdown = MenuDropdown;
ExtendedMenu.Item = TombacItem;
ExtendedMenu.Root = MenuRoot;
export { MenuAction, MenuItem } from "./LegacyMenu";
export { ExtendedMenu as Menu };
//# sourceMappingURL=Menu.js.map